import Slider from 'javascripts/globals/slider';

document.querySelectorAll('.mag-stage.js-slider').forEach($magStage => new Slider($magStage, {
  sliderFrame: 'mag-stage__inner',
  slidesContainer: 'mag-stage__slides',
  sliderSlide: 'mag-stage__slide',
  sliderControlsframe: 'mag-stage__controls-inner',
  sliderControlsframemethod: 'prepend',
}));
